import { useRouter } from 'next/router';
import React from 'react';
import MillesimaLink from '@/components/common/MillesimaLink';
import { PAGES } from '@/constants/pages';
import { FooterLinkColumnModel, FooterLinkModel } from '@/models';
import { useAppDispatch } from '@/redux';
import { showModal } from '@/redux/slices/gui.slice';
import { normalizeUrl } from '@/utils/menuUtils';
import styles from './FooterBottomLinks.module.scss';

type FooterBottomLinksProps = {
	links: FooterLinkColumnModel[];
	isMobile?: boolean;
};

const isNofollow = (link: FooterLinkModel, pathname: string): boolean =>
	Boolean(pathname === PAGES.HOME ? link.isNofollow : link.isNofollowExclHome);

const FooterBottomLinks = ({ links, isMobile = false }: FooterBottomLinksProps): React.JSX.Element => {
	const router = useRouter();
	const dispatch = useAppDispatch();

	const handleDataToggle = (e, link) => {
		dispatch(showModal({ id: link.dataTarget.substring(1) }));
		e.preventDefault();
	};

	return (
		<>
			{links.map((item) => (
				<div key={item.title} className={styles.section}>
					{item.title && <span className={styles.title}>{item.title} :&nbsp;</span>}
					{item.footerLinks?.map((link, i) => {
						const { id, name, url, dataToggle, dataTarget, isTargetBlank } = link;
						const key = `${id}-${i}`;

						return dataToggle ? (
							<span key={key} className={styles.link}>
								<a
									href={url}
									data-toggle={dataToggle}
									data-target={dataTarget}
									id={id}
									aria-label={name}
									onClick={(e) => handleDataToggle(e, link)}
									data-test-id="footer-bottom-links-a"
								>
									{name}
								</a>
							</span>
						) : (
							<MillesimaLink
								key={key}
								customClassName={{ container: styles.link }}
								href={normalizeUrl(url)}
								ariaLabel={name}
								isTargetBlank={!isMobile && isTargetBlank}
								isNofollow={isNofollow(link, router.pathname)}
							>
								{name}
							</MillesimaLink>
						);
					})}
				</div>
			))}
		</>
	);
};

export default FooterBottomLinks;
